import React from "react";
import { useIntl } from "react-intl";
import TextInputField from "./text-input-field";
import sharedMessages from "../../../../shared-messages";

const FamilyNameField = () => {
  const { formatMessage } = useIntl();

  return (
    <TextInputField
      id="family-name"
      className="family-name"
      name="familyName"
      label={formatMessage(sharedMessages.lastNameOptional)}
      autocomplete="family-name"
    />
  );
};

export default FamilyNameField;
